import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "credentialsSection", "credentialFields"]
  static values = { 
    platformFieldsUrl: String 
  }

  connect() {
    this.handleInitialState()
  }

  handleInitialState() {
    // If there's already a platform selected on page load, show the credentials section
    if (this.selectTarget.value) {
      this.showCredentialsSection()
    }
  }

  platformChanged(event) {
    const platformId = event.target.value

    if (platformId) {
      this.loadPlatformFields(platformId)
    } else {
      this.hideCredentialsSection()
    }
  }

  async loadPlatformFields(platformId) {
    try {
      this.showCredentialsSection()
      this.showLoadingState()

      const url = `${this.platformFieldsUrlValue}?platform_id=${platformId}`
      console.log("Making request to:", url)

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Accept": "text/html, application/html",
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRF-Token": this.getCSRFToken()
        },
        credentials: "same-origin"
      })

      console.log("Response status:", response.status)

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status} - ${response.statusText}`)
      }

      const html = await response.text()
      console.log("Received HTML length:", html.length)

      this.credentialFieldsTarget.innerHTML = html
      console.log("Successfully loaded credential fields for platform:", platformId)

    } catch (error) {
      console.error("Error loading credential fields:", error)
      this.showErrorState(error.message)
    }
  }

  showCredentialsSection() {
    this.credentialsSectionTarget.classList.remove("hidden")
  }

  hideCredentialsSection() {
    this.credentialsSectionTarget.classList.add("hidden")
    this.credentialFieldsTarget.innerHTML = ""
  }

  showLoadingState() {
    this.credentialFieldsTarget.innerHTML = `
      <div class="bg-theme-background-alt/50 rounded-lg p-4 text-center">
        <div class="inline-flex items-center space-x-2">
          <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-theme-info"></div>
          <span class="text-sm text-theme-light">Loading platform fields...</span>
        </div>
      </div>
    `
  }

  showErrorState(errorMessage) {
    this.credentialFieldsTarget.innerHTML = `
      <div class="bg-red-900/50 border border-red-700 rounded-lg p-4">
        <p class="text-red-400">Error loading platform fields: ${errorMessage}</p>
        <p class="text-red-300 text-xs mt-2">Check console for details. Please refresh and try again.</p>
      </div>
    `
  }

  getCSRFToken() {
    // Try multiple ways to get the CSRF token
    const metaToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    const inputToken = document.querySelector('input[name="authenticity_token"]')?.value
    const token = metaToken || inputToken

    if (!token) {
      console.warn("CSRF token not found")
    }

    return token
  }
}